import React from 'react'
import { Box } from '@chakra-ui/react'

function TwoCols(props) {
  return (
    <Box
      dangerouslySetInnerHTML={{
        __html: `${props.content}`,
      }}
      sx={{
        columnCount: [1, 1, 2],
        columnGap: [0, 0, '3rem'],
        '*:first-child': {
          marginTop: 0,
        },
      }}
    />
  )
}

export default TwoCols
